export default function FlagPanel({ reviews }) {
  if (!reviews?.length) return null;

  const flags = [];
  reviews.forEach(r => {
    if (r.sector_concentration_flag) {
      flags.push({ type: 'Sector Concentration', notes: r.sector_concentration_notes, reviewer: r.reviewer_id, reviewType: r.review_type });
    }
    if (r.obligor_exposure_flag) {
      flags.push({ type: 'Single Obligor Exposure', notes: r.obligor_exposure_notes, reviewer: r.reviewer_id, reviewType: r.review_type });
    }
    if (r.dry_powder_flag) {
      flags.push({ type: 'Dry Powder', notes: r.dry_powder_notes, reviewer: r.reviewer_id, reviewType: r.review_type });
    }
  });

  if (!flags.length) return null;

  return (
    <div style={{ marginTop: 12 }}>
      {flags.map((flag, i) => (
        <div key={i} style={{
          display: 'flex',
          gap: 10,
          padding: '8px 12px',
          marginBottom: 6,
          background: 'var(--color-warning-bg)',
          border: '1px solid #fcd34d',
          borderRadius: 'var(--radius)',
        }}>
          <span style={{ fontSize: 14 }}>⚑</span>
          <div>
            <p style={{ fontSize: 13, fontWeight: 600, color: 'var(--color-warning)' }}>{flag.type}</p>
            {flag.notes && <p style={{ fontSize: 12, color: 'var(--color-text)', marginTop: 2 }}>{flag.notes}</p>}
          </div>
        </div>
      ))}
    </div>
  );
}
